import { render } from "./EventProtectionView.vue?vue&type=template&id=cf05102a&scoped=true"
import script from "./EventProtectionView.vue?vue&type=script&lang=js"
export * from "./EventProtectionView.vue?vue&type=script&lang=js"

import "./EventProtectionView.vue?vue&type=style&index=0&id=cf05102a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf05102a"]])

export default __exports__